"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  highlightPreTag: "<ais-highlight-0000000000>",
  highlightPostTag: "</ais-highlight-0000000000>"
};


//////////////////
// WEBPACK FOOTER
// ./~/react-instantsearch/src/core/highlightTags.js
// module id = 468
// module chunks = 142807904292071